import { render, staticRenderFns } from "./BaseExportDownload.vue?vue&type=template&id=46971370&"
import script from "./BaseExportDownload.vue?vue&type=script&lang=js&"
export * from "./BaseExportDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports